import React, { forwardRef } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import classNames from "classnames";

const ScrollBar = forwardRef((props, ref) => {
  const { direction = "ltr", ...rest } = props;

  return (
    <Scrollbars
      ref={ref}
      renderView={(props) => (
        <div
          className={classNames("", rest?.className)}
          {...props}
          style={{
            ...props.style,
            ...(direction === "rtl" && {
              marginLeft: props.style.marginRight,
              marginRight: 0,
            }),
          }}
        />
      )}
      {...rest}
    />
  );
});

export default ScrollBar;
